const targetReportEnvs = {
  azureDEV: {
    ssoPath: 'https://dev-insights.pathway.ey.com/Insights',
  },
  azureDEV2: {
    ssoPath: 'https://dev2-insights.pathway.ey.com/Insights',
  },
  azureDEV3: {
    ssoPath: 'https://dev3-insights.pathway.ey.com/Insights',
  },
  azureDEVPOC: {
    ssoPath: 'https://dev3-insights.pathway.ey.com/Insights',
  },
  azureQA: {
    ssoPath: 'https://qa-insights.pathway.ey.com/Insights',
  },
  azureQA2: {
    ssoPath: 'https://qa2-insights.pathway.ey.com/Insights',
  },
  azureQA3: {
    ssoPath: 'https://qa3-insights.pathway.ey.com/Insights',
  },
  azureQAPOC: {
    ssoPath: 'https://qa3-insights.pathway.ey.com/Insights',
  },
  azureUAT: {
    ssoPath: 'https://uat-insights.pathway.ey.com/Insights',
  },
  azureUAT2: {
    ssoPath: 'https://uat2-insights.pathway.ey.com/Insights',
  },
  azureUATDE: {
    ssoPath: 'https://uat-insights-pathway-eu.ey.com/Insights',
  },
  azureSTG: {
    ssoPath: 'https://stg-insights.pathway.ey.com/Insights',
  },
  azurePROD: {
    ssoPath: 'https://insights.pathway.ey.com/Insights',
  },
  azurePRODDE: {
    ssoPath: 'https://insights-pathway-eu.ey.com/Insights',
  },
  azureDEMO: {
    ssoPath: 'https://demo-insights.pathway.ey.com/Insights',
  },
  local: {
    ssoPath: null,
  },
};

const targetReportEnv = process.env.TARGET_ENV || 'local';
export const reportUrls = targetReportEnvs[targetReportEnv].ssoPath;
